import React from 'react';
// import Header from '../MyComponent/Header';
import Banner from '../MyComponent/Banner'
import Cards from '../MyComponent/Card'
import Seller from '../MyComponent/Sellers'
import Makingunique from '../MyComponent/Makingunique'
import Silder from '../MyComponent/SilderCart'
import Seo from '../MyComponent/Seo'
import { EditorialIntro, EditorialSections } from '../MyComponent/EditorialContent'
import { homeContent } from '../content/siteContent'

// import Footer from '../MyComponent/footer';

const Home = () => {
    return (
        <>
            <Seo {...homeContent} />
            <Banner />
            <EditorialIntro heading={homeContent.heading} intro={homeContent.intro} eyebrow="Made in Sevierville, Tennessee" />
            <Cards />
            <Seller />
            <EditorialSections sections={homeContent.sections} ariaLabel="Discover Craig Photo Letters" />
            <Makingunique />
            <Silder />
        </>
    );
};

export default Home;
